import __request__ from "routing/request";
export function allFieldTypes(requestOptions) {
  return __request__("GET", "/views/fields", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function byStreams(JSONbody, requestOptions) {
  return __request__("POST", "/views/fields", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function triggerFieldTypePolling(requestOptions) {
  return __request__("POST", "/views/fields/poll", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
